// extracted by mini-css-extract-plugin
export var taskNavigationSection = "AdjacentTaskNavigator-module--taskNavigationSection--1C9MA";
export var prev = "AdjacentTaskNavigator-module--prev--4XTpI";
export var arrow = "AdjacentTaskNavigator-module--arrow--1FFT2";
export var prevContent = "AdjacentTaskNavigator-module--prevContent--1UbvT";
export var next = "AdjacentTaskNavigator-module--next--KgafL";
export var nextContent = "AdjacentTaskNavigator-module--nextContent--28k6o";